/**
 * @memberof module:util
 * @function
 * @name getPrice
 * @description return price with two decimal points
 *
 * @param {*} price - price to be converted to two decimal points
 * @returns {number}
 *
 * @example
 * console.log(getPrice("33.339")); //33.34
 * console.log(getPrice(null)); //0
 */

export const getPrice = (price) => {
  price = Number(price);
  price = isNaN(price) ? 0 : price;
  price = Number(parseFloat(price).toFixed(2));
  return price;
};
